import React from "react";
import PropTypes from "prop-types";
import { Accordion } from "react-bootstrap";

import RichTextBlock from "./RichTextBlock";

import "../styles/components/AccordionEventDescription.scss";

const AccordionEventDescription = ({
    description,
    eventKey,
    ToggleComponent,
}) => (
    <div className="accordion-event-description my-2">
        <ToggleComponent eventKey={eventKey} />
        <Accordion.Collapse eventKey={eventKey}>
            <RichTextBlock content={description} />
        </Accordion.Collapse>
    </div>
);

AccordionEventDescription.propTypes = {
    description: PropTypes.shape({ raw: PropTypes.string }).isRequired,
    eventKey: PropTypes.string.isRequired,
    ToggleComponent: PropTypes.elementType.isRequired,
};

export default AccordionEventDescription;
